import { GlobalStateDropdown } from 'Feature/NowNavigation/GlobalStateDropdown';
import MainNavigation from 'Feature/NowNavigation/MainNavigation';
import { getLogoutLink, getSettingsLink, isBL, isPL } from 'Foundation/Configurations/GlobalConfiguration';
import { useUserData } from 'Foundation/User/UserContext';
import './PageHeader.scss';
import { IconButton, IconClose, IconMenu, IconSettings } from '@lmig/lmds-react-icons';
import { redirectTo } from 'Utilities/NavigationHelper';
import { FloatingHeader } from '@lmig/lmds-react-floating-header';
import { Notification } from '@lmig/lmds-react-notification';
import { LogoutUserAsync } from 'Feature/Admin/Helpers/AdminApi';
import { PageHeaderDropdown } from './PageHeaderDropdown';
import { MouseEvent, useState } from 'react';
import { BLDropdown } from 'Feature/StatCodeDropdown/BLdropdown';
import { PLDropdown } from 'Feature/StatCodeDropdown/PLdropdown';

export function PageHeader() {
  const { userData } = useUserData();
  const [menuIsOpen, setMenuIsOpen] = useState<boolean>(false);

  const openMenu = () => setMenuIsOpen(true);
  const closeMenu = () => setMenuIsOpen(false);

  const openSettings = () => {
    if (userData?.isBL()) window.open(getSettingsLink(true), '_blank');
    else redirectTo(getSettingsLink(false));
  };

  const displayUserIdInHeader = (): boolean => {
  if (userData?.isAgent() && userData.userIdNoAuthSuffix()) {
    return true;
  }
  return false;
};

  const mockingAgentNotification = () => {
    if (userData?.isMockingAgent) {
      return (
        <Notification
          highlightType="caution"
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '12px',
            flex: '1 0 0',
            alignSelf: 'stretch',
          }}
        >
          You are mocking {userData.name} (Agency owner) {`${userData?.userIdNoAuthSuffix()}`}
        </Notification>
      );
    }
  };

  const agencyCodeSelector = () => {
    if (userData?.isMockingAgent || userData?.isAgent()) {
      return userData?.isBL() ? <BLDropdown /> : <PLDropdown />
    }
  };

  const handleLogout = async (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    try {
      const isBusinessLinesUser = userData?.isBL() ?? false;
      await LogoutUserAsync();
      const logoutUrl = getLogoutLink(isBusinessLinesUser);
      
      window.location.assign(logoutUrl);
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  return (
    <div id="page-header-container">
      {userData && (
        <>
          {mockingAgentNotification()}
          <div id="page-header-inner">
            <div className="page-header-utility">
              {/* I had to move the code here into smaller chunks to make sure the notification could
              stay above the page-header-inner and keep the code selector below the page-header-utility,
              otherwise, it wouldn't appaear correctly*/}
              <div className='page-header-group top-row'>
                <div className='page-header-section'>
                  {agencyCodeSelector()}
                </div>
                <div className='page-header-section'>
                  {userData && <GlobalStateDropdown />}
                </div>
                <div className='page-header-section agent-portal-dropdown'>
                  <PageHeaderDropdown headerLabel={'Agent portals'}/>
                </div>
                <div className={`page-header-section page-header-menu-button ${menuIsOpen ? 'open' : 'closed'}`}>
                  <IconButton 
                    background="transparent" 
                    width={16} height={16}
                    initialSize='16'
                    size={16}
                    // isLargeOnMobile={false}
                    type="button"
                    
                    onClick={() => menuIsOpen ? closeMenu() : openMenu()}
                    >
                    {menuIsOpen 
                      ? <IconClose width={16} height={16} /> 
                      : <IconMenu width={16} height={16} />
                    }
                  </IconButton>
                </div>
              </div>
              <div className={`page-header-group bottom-row ${menuIsOpen ? 'open' : 'closed'}`}>
                <div className={`page-header-section`}>
                  <a
                    className="settings lm-Link lm-LinkStandalone cursor-pointer" 
                    onClick={() => openSettings()}
                  >
                    <IconSettings width={16} height={16}></IconSettings>
                    <div className="settings-text"> Settings</div>
                  </a>
                </div>
                <div className={`page-header-section`}>
                  <a
                    className="lm-Link lm-LinkStandalone logout-link cursor-pointer"
                    onClick={(event) => handleLogout(event)}
                  >
                    Log out {displayUserIdInHeader() && `(${userData?.userIdNoAuthSuffix()})`}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {userData ? (
        <MainNavigation />
      ) : (
        <FloatingHeader
          className="public-site-header"
          brand="liberty"
          appName={isPL() ? 'Personal lines' : isBL() ? 'Small commercial' : ''}
          isFullWidth={true}
          hideDivider={true}
        />
      )}
      <div id="agency-codes-mobile-slot" />
    </div>
  );
}
